/**
 * Directory – Directory & Listing Bootstrap 4 Theme v. 1.4.2
 * Homepage: https://themes.getbootstrap.com/product/directory-directory-listing-bootstrap-4-theme/
 * Copyright 2020, Bootstrapious - https://bootstrapious.com
 */

"use strict";

import L from "leaflet";

export const createDetailMap = (options) => {
  var mapZoom = window.preview_shell ? 4 : 14;
  var markerShow = window.preview_shell ? false : true;

  var defaults = {
    mapZoom: mapZoom,
    markerShow: markerShow,
    markerPath: "/static/images/tab-marker.svg",
    circleShow: true,
    circleColour: "#6c768688",
    circleFill: "#6c7686",
    circleOpacity: 0.05,
    circleRadius: 1000,
    tileLayer: {
      tiles: `https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/256/{z}/{x}/{y}@2x?access_token=${window.mapboxApiKey}`,
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    },
  };

  var settings = $.extend({}, defaults, options);

  var icon = L.icon({
    iconUrl: settings.markerPath,
    iconSize: [25, 37.5],
    popupAnchor: [0, -18],
    tooltipAnchor: [0, 19],
  });

  var dragging = false,
    tap = false;

  if ($(window).width() > 700) {
    dragging = true;
    tap = true;
  }

  var detailMap = L.map(settings.mapId, {
    center: settings.mapCenter,
    zoom: settings.mapZoom,
    dragging: dragging,
    tap: tap,
    scrollWheelZoom: false,
  });

  detailMap.once("focus", function () {
    detailMap.scrollWheelZoom.enable();
  });

  L.tileLayer(settings.tileLayer.tiles, {
    attribution: settings.tileLayer.attribution,
    minZoom: 1,
    maxZoom: 19,
  }).addTo(detailMap);

  if (settings.circleShow) {
    L.circle(settings.circlePosition, {
      color: settings.circleColour,
      weight: 2,
      fillColor: settings.circleFill,
      fillOpacity: settings.circleOpacity,
      radius: settings.circleRadius,
    }).addTo(detailMap);
  }

  if (settings.markerShow) {
    L.marker(settings.markerPosition, {
      icon: icon,
    }).addTo(detailMap);
  }

  return detailMap;
};

export const highlightMarker = (marker) => {
  let children = Array.prototype.slice.call(marker._icon.children);
  children.forEach((child) => {
    child.classList.add("active");
  });
};

export const resetMarker = (marker) => {
  let children = Array.prototype.slice.call(marker._icon.children);
  children.forEach((child) => {
    child.classList.remove("active");
  });
};
